import { type BuyButtonProps } from '@capsicum/features/fan-token-offering/shared';

import { FTOBuyButton } from './FTOBuy';

/**
 * Component for FTO card that display a timer or a buy button depending if the Campaign is opened or not
 *
 * @param {startDate} props.startDate date the campaign is opened
 * @param {status} props.status status of the campaign (Opened, published, closed)
 * @param {quantityAvailable} props.quantityAvailable amount if fan token the user can buy
 * @param {shortCode} props.shortCode partner short code
 * @param {partnerId} props.partnerId Id of the campaign's partner
 *
 * @returns {JSX.Element} a Buy button or a Timer
 */
export const BuyButton = ({ onBuyClick, partnerId, quantityAvailable, shortCode, status, testID }: BuyButtonProps) => {
	return (
		<FTOBuyButton
			partnerId={partnerId}
			quantityAvailable={quantityAvailable}
			shortCode={shortCode}
			status={status}
			testID={testID}
			onBuyClick={onBuyClick}
		/>
	);
};
